import { render, staticRenderFns } from "./CreateServicePreview.vue?vue&type=template&id=99a7ce0c&scoped=true"
import script from "./CreateServicePreview.vue?vue&type=script&lang=js"
export * from "./CreateServicePreview.vue?vue&type=script&lang=js"
import style0 from "./CreateServicePreview.vue?vue&type=style&index=0&id=99a7ce0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7ce0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
